import { Converter } from '../types/converter';

export const volumeDryConverter: Converter = {
  id: 'volumeDry',
  name: 'Dry Volume Converter',
  icon: 'Box',
  categories: ['common'],
  units: [
    // Base unit - Liter
    { name: 'Liter', symbol: 'L', factor: 1 },
    
    // US dry measures
    { name: 'Barrel dry (US)', symbol: 'bbl dry (US)', factor: 115.6271 },
    { name: 'Bushel (US)', symbol: 'bu (US)', factor: 35.23907016688 },
    { name: 'Peck (US)', symbol: 'pk (US)', factor: 8.809767541720 },
    { name: 'Quart dry (US)', symbol: 'qt dry (US)', factor: 1.101470942715 },
    { name: 'Pint dry (US)', symbol: 'pt dry (US)', factor: 0.5507354713575 },
    
    // UK dry measures
    { name: 'Bushel (UK)', symbol: 'bu (UK)', factor: 36.36872 },
    { name: 'Peck (UK)', symbol: 'pk (UK)', factor: 9.09218 },
    
    // Biblical measures
    { name: 'Cor (Biblical)', symbol: 'cor', factor: 220 },
    { name: 'Homer (Biblical)', symbol: 'homer', factor: 220 },
    { name: 'Ephah (Biblical)', symbol: 'ephah', factor: 22 },
    { name: 'Seah (Biblical)', symbol: 'seah', factor: 7.33 },
    { name: 'Omer (Biblical)', symbol: 'omer', factor: 2.2 },
    { name: 'Cab (Biblical)', symbol: 'cab', factor: 1.22 },
    { name: 'Log (Biblical)', symbol: 'log', factor: 0.31 }
  ]
};
